import {useLocalStorage} from 'react-use';
import {ANONYMOUS_ID_NAMESPACE} from '../ev-ampol-amp-charge/constants';
import {v4 as uuid} from 'uuid';

export const useAnonymousId = () => {
  const [value] = useLocalStorage<string>(ANONYMOUS_ID_NAMESPACE, uuid());

  return {anonymousId: value};
};
